import type { ReactNode } from "react";

/** Vertical gaps (px) for `Stack`, so MC pages share one rhythm. */
export const GAP = {
  /** Between cards and banners on a page */
  page: 32,
  /** Between sections inside a card or modal */
  section: 28,
  /** Between related pieces within a section */
  block: 20,
};

/** A small heading for a section inside a card or modal. */
export const SectionHeading = ({ children, className = "" }: { children: ReactNode; className?: string }) => (
  <h3 className={`mb-3 text-sm font-semibold text-gray-700 ${className}`}>{children}</h3>
);
